import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import useAuth from '../hooks/useAuth.js';

export default function PublicRoute({ children }) {
  const { user } = useAuth();
  const location = useLocation();

  if (user) return <Navigate to="/" state={{ from: location }} replace />;

  return <>{children}</>;
}
